export default __webpack_public_path__ + "static/brecon-wind-turbine-926af2766ec99c519d5122dbf93de382.webp";